import { Observable } from 'rxjs';
import { ShippingBacklogCancellationRequest } from '../../model/shipping-backlog.model';

export abstract class ShippingBacklogCancellationAdapter {
  abstract sendCancellationRequest(
    request: ShippingBacklogCancellationRequest
  ): Observable<void>;
}
